import { Component, OnInit, Input, Output, EventEmitter, OnDestroy  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { LoanService } from '../../services/loan.service';
import { EmployeeService } from '../../services/employee.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-create-loan',
    templateUrl: './create-loan.component.html',
    styleUrls: ['./create-loan.component.css', '../../app.component.css']
})

export class CreateLoanComponent implements OnInit, OnDestroy {

    loanForm: FormGroup;
    loan: any;

    employees = {};
    employeeInit: any;
    employeeText = '';

    authorizes = {};
    authorizeInit: any;
    authorizeText = '';

    pickadateParams = Utils.pickadateParams();

    geSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private loanService: LoanService,
                private employeeService: EmployeeService) {
        this.loadEmployeesAndAuthorizes();
    }

    ngOnInit() {
        this.loanForm = this.formBuilder.group({
            loanDate: ['', Validators.required],
            employee: ['', Validators.required],
            authorize: ['', Validators.required],
            loanAmount: ['', Validators.required],
            discountPerPayroll: ['', [Validators.required]]
        });
    }
    ngOnDestroy() {
        this.geSubs.unsubscribe();
    }

    onSubmitLoan() {
        this.loan = this.saveLoan();

        this.loanService.postLoan(this.loan).then(res => {
            this.loanForm.reset();

            this.router.navigate(['/loans']);
        });
    }

    saveLoan() {
        const loanDate = Utils.convertDatefromISOStringtoObject(this.loanForm.get('loanDate').value);

        const currentDate = new Date();

        const loanJson = {
            active: 1,
            authorizeId: this.authorizes[this.loanForm.get('authorize').value],
            authorizeName: this.loanForm.get('authorize').value,
            discountPerPayroll: this.loanForm.get('discountPerPayroll').value,
            createdAt: currentDate,
            employeeId: this.employees[this.loanForm.get('employee').value],
            employeeName: this.loanForm.get('employee').value,
            loanAmount: this.loanForm.get('loanAmount').value,
            loanDate: loanDate,
            updatedAt: currentDate,
            remainingAmount: this.loanForm.get('loanAmount').value
        };

        return loanJson;
    }

    loadEmployeesAndAuthorizes() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            const data = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                data[employeeDisplayValue] = null;

                this.employees[employeeDisplayValue] = tempEmployees[idx].id$;
                this.authorizes[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.employeeInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.employees[val]);
                }
            };

            this.authorizeInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.authorizes[val]);
                }
            };
        });
    }

    onBlurEmployee() {
        if (this.employees[this.employeeText] === undefined) {
            this.employeeText = '';
        }
    }

    onBlurAuthorize() {
        if (this.authorizes[this.authorizeText] === undefined) {
            this.authorizeText = '';
        }
    }

}

